/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import LoginLandingComponent from './loginLanding.Components';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
import { configSettings } from "../../config/configSettings";
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class LoginLanding extends Component {
    constructor(props) {
        super(props);
        const query = new URLSearchParams(this.props.location.search);
        const userName = query.get('userName');
        const response = query.get('response');
        this.state = {
            userName: userName,
            response: response
        };
    };

    componentWillMount() {
        this.checkAndNavigatToAnotherPage(this.props.user.loggedIn, this.props.user.roleName);
    }

    checkAndNavigatToAnotherPage(loggedIn, roleName) {
        if (loggedIn) {
            if (roleName === Constants.ADMIN_ROLE_NAME) {
                this.props.history.push("/Security");
            }
            else {
                this.props.history.push("/Projects");
            }
        }
    }

    componentDidMount() {
        if (this.state.response === null) {
            this.getLoginUserDetails();
        }
    }

    getLoginUserDetails() {
        let requestData = {
            UserName: this.state.userName,
            Password: "password"
        };
        let url = ApiUrls.Routes.ACNT_C + ApiUrls.Routes.GT_LGN_TKN_M;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData.success) {
                if (responseData.data.isLoginSuccess) {
                    //Added to prevent user getting logged in again after clicking browser
                    //back button 
                    this.props.history.replace("/Login", "");
                    MessageBox(responseData.message, Constants.SUCCESS);
                    this.props.login(
                        responseData.data.isLoginSuccess,
                        responseData.data.firstName,
                        responseData.data.lastName,
                        responseData.data.fullName,
                        responseData.data.email,
                        responseData.data.phoneNumber,
                        responseData.token,
                        responseData.data.userName,
                        responseData.data.userId,
                        responseData.data.roleId,
                        responseData.data.roleName,
                        responseData.data.claimValue
                    );
                    this.checkAndNavigatToAnotherPage(responseData.data.isLoginSuccess, responseData.data.roleName);
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }
    ssohandleLogin = () => {
        let url = configSettings.loginAPI + ApiUrls.Routes.ACNT_C + ApiUrls.Routes.LGN_SSO + "?response=" + this.state.response;
        window.location.href = url;
    }

    render() {
        const { response } = this.state;
        return (
            <Fragment>
                <LoginLandingComponent
                    {...{
                        LoginLanding: {
                            response
                        }
                    }}
                    user={this.props.user}
                    ssohandleLogin={this.ssohandleLogin.bind(this)}
                />
            </Fragment>
        )
    }
};

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginLanding));

LoginLanding.displayName = 'LoginLanding';